var SupportV2StepActionsModel;

SupportV2StepActionsModel = (function() {
  function SupportV2StepActionsModel(options) {
    if (options == null) {
      options = {};
    }
    this.options = options;
  }

  SupportV2StepActionsModel.prototype.toHash = function() {
    var hash, ref, ref1;
    hash = {
      isV2: true,
      contToStepTwoBtnText: I18n.t("js.modules.support.contorder"),
      needHelpBtnText: I18n.t("js.modules.support.needhelp"),
      refundMyRequest: I18n.t("js.modules.support.req_my_refund"),
      contToStepThreeBtnText: I18n.t("js.modules.support.cont"),
      orderId: ((ref = Groupon.Support.currentOrder) != null ? ref.id : void 0) != null ? Groupon.Support.currentOrder.id.toString() : "noorder",
      tagline: Groupon.Support.Tagline != null ? Groupon.Support.Tagline : "",
      isPriorityViewsEnabled: window.priorityViewsEnabled(),
      isRefundEligible: window.evaluate((ref1 = Groupon.Support.ContentModel) != null ? ref1.isRefundEligible : void 0)
    };
    if (this.options.showVerticalView) {
      hash.showVerticalView = true;
    }
    if (Groupon.Support.MAXINDEX === 3) {
      if (Groupon.Support.CURRENTVIEW.id === 1) {
        if (Groupon.Support.currentOrder) {
          _.extend(hash, window.getOrderInfoForBH(Groupon.Support.currentOrder));
          hash.showOrderDetailsActions = true;
        } else {
          hash.showOrderListingActions = true;
        }
      } else if (Groupon.Support.CURRENTVIEW.id === 2) {
        hash.showChat = Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat();
      }
    } else if (Groupon.Support.MAXINDEX === 2) {
      if (Groupon.Support.CURRENTVIEW.id === 1) {
        hash.showChat = Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat();
      }
    }
    return hash;
  };

  return SupportV2StepActionsModel;

})();

module.exports = SupportV2StepActionsModel;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvbW9kZWxzL3YyX3N0ZXBfYWN0aW9uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL21vZGVscy92Ml9zdGVwX2FjdGlvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBQTs7QUFBTTtFQUVTLG1DQUFDLE9BQUQ7O01BQUMsVUFBUzs7SUFDckIsSUFBQyxDQUFBLE9BQUQsR0FBVztFQURBOztzQ0FHYixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLEdBQ0U7TUFBQSxJQUFBLEVBQU8sSUFBUDtNQUNBLG9CQUFBLEVBQXVCLElBQUksQ0FBQyxDQUFMLENBQU8sOEJBQVAsQ0FEdkI7TUFFQSxlQUFBLEVBQWlCLElBQUksQ0FBQyxDQUFMLENBQU8sNkJBQVAsQ0FGakI7TUFHQSxlQUFBLEVBQWlCLElBQUksQ0FBQyxDQUFMLENBQU8sa0NBQVAsQ0FIakI7TUFJQSxzQkFBQSxFQUF3QixJQUFJLENBQUMsQ0FBTCxDQUFPLHlCQUFQLENBSnhCO01BS0EsT0FBQSxFQUFZLHdFQUFILEdBQTBDLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDLEVBQUUsQ0FBQyxRQUFoQyxDQUFBLENBQTFDLEdBQTBGLFNBTG5HO01BTUEsT0FBQSxFQUFZLCtCQUFILEdBQWlDLE9BQU8sQ0FBQyxPQUFPLENBQUMsT0FBakQsR0FBOEQsRUFOdkU7TUFPQSxzQkFBQSxFQUF3QixNQUFNLENBQUMsb0JBQVAsQ0FBQSxDQVB4QjtNQVFBLGdCQUFBLEVBQWtCLE1BQU0sQ0FBQyxRQUFQLHFEQUE0QyxDQUFFLHlCQUE5QyxDQVJsQjs7SUFVRixJQUFHLElBQUMsQ0FBQSxPQUFPLENBQUMsZ0JBQVo7TUFDRSxJQUFJLENBQUMsZ0JBQUwsR0FBd0IsS0FEMUI7O0lBR0EsSUFBRyxPQUFPLENBQUMsT0FBTyxDQUFDLFFBQWhCLEtBQTRCLENBQS9CO01BQ0UsSUFBRyxPQUFPLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FBQyxFQUE1QixLQUFrQyxDQUFyQztRQUNFLElBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFuQjtVQUNFLENBQUMsQ0FBQyxNQUFGLENBQVMsSUFBVCxFQUFlLE1BQU0sQ0FBQyxpQkFBUCxDQUF5QixPQUFPLENBQUMsT0FBTyxDQUFDLFlBQXpDLENBQWY7VUFDQSxJQUFJLENBQUMsdUJBQUwsR0FBK0IsS0FGakM7U0FBQSxNQUFBO1VBSUUsSUFBSSxDQUFDLHVCQUFMLEdBQStCLEtBSmpDO1NBREY7T0FBQSxNQU1LLElBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsRUFBNUIsS0FBa0MsQ0FBckM7UUFDSCxJQUFJLENBQUMsUUFBTCxHQUFpQixPQUFPLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyx5QkFBOUIsQ0FBQSxFQURkO09BUFA7S0FBQSxNQVNLLElBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxRQUFoQixLQUE0QixDQUEvQjtNQUNILElBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsRUFBNUIsS0FBa0MsQ0FBckM7UUFDRSxJQUFJLENBQUMsUUFBTCxHQUFnQixPQUFPLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyx5QkFBOUIsQ0FBQSxFQURsQjtPQURHOztXQUlMO0VBNUJNOzs7Ozs7QUE4QlYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
